import type { FormElement, ParagraphProperties } from '../../model/form.types';
import type { FieldDefinition } from '../../model/types';
import { builderDefaultText, isEmptyValue, maxLengthIssue, requiredIssue, singleColumn, stringShapeIssue, valueAsText } from './shared';

type ParagraphElement = FormElement & { properties: ParagraphProperties };

export const PARAGRAPH_MAX_LENGTH = 1000;

export const paragraphDefinition: FieldDefinition<ParagraphElement> = {
  kind: 'field',
  type: 'PARAGRAPH',
  emptyValue: builderDefaultText,
  control: (element) => ({ kind: 'textarea', placeholder: element.properties.placeholder, maxLength: PARAGRAPH_MAX_LENGTH }),
  shapeIssue: stringShapeIssue,
  validate: (element, value) => {
    const shape = stringShapeIssue(element, value);
    if (shape) return [shape];
    if (typeof value !== 'string' || isEmptyValue(value)) {
      return element.properties.required ? [requiredIssue(element)] : [];
    }
    return value.length > PARAGRAPH_MAX_LENGTH ? [maxLengthIssue(element, PARAGRAPH_MAX_LENGTH)] : [];
  },
  columns: singleColumn,
  cells: (_element, value) => [valueAsText(value)],
  triggerMatches: () => false,
};
